import { render, staticRenderFns } from "./CompetenzeList.vue?vue&type=template&id=6936127e&scoped=true&"
import script from "./CompetenzeList.vue?vue&type=script&lang=js&"
export * from "./CompetenzeList.vue?vue&type=script&lang=js&"
import style0 from "./CompetenzeList.vue?vue&type=style&index=0&id=6936127e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936127e",
  null
  
)

export default component.exports